import formatDateWithTimezone from "@insite/client-framework/Common/Utilities/formatDateWithTimezone";

import { ApiHandlerDiscreteParameter, HasOnError, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { Cart, CartResult, UpdateCartApiParameter } from "@insite/client-framework/Services/CartService";

import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/PlaceOrder";
import CustomApplicationState from "@tCentro/Store/CustomApplicationState";

const convertDateToApiFormat = (date: Date | null) => (date ? formatDateWithTimezone(date) : "");

interface PlaceOrderParameter {
    paymentMethod: string;
    poNumber: string;
    vatNumber?: string;
    saveCard: boolean;
    cardHolderName: string;
    cardNumber: string;
    cardType: string;
    expirationMonth: number;
    expirationYear: number;
    securityCode: string;
    useBillingAddress: boolean;
    address1: string;
    countryId: string;
    stateId: string;
    city: string;
    postalCode: string;
    onSuccess?: (cartId: string) => void;
    payPalToken?: string;
    payPalPayerId?: string;
    isPending?: boolean;
    isAdyenDropIn?: boolean;
    adyenPspReference?: string;
    accountHolderName?: string;
    accountNumber?: string;
    routingNumber?: string;
}

type HandlerType = ApiHandlerDiscreteParameter<
    PlaceOrderParameter & HasOnError,
    UpdateCartApiParameter,
    CartResult,
    {
        cartToUpdate: Cart;
    }
>;

export const PopulateApiParameterExtended: HandlerType = props => {
    const state = props.getState() as CustomApplicationState;
    const orderNotesDescription = state.t_components.OrderNotes.OrderNotes;
    const accountNo = state.t_components.collectAccountNumber.collectAccountNumber;
    const cenopcPONumber = state.t_components.SpcPONumber.SpcPONumber;
    const gclid = sessionStorage.getItem("gclid") || "";

    if (!props.cartToUpdate) {
        return;
    }

    const {
        pages: {
            checkoutReviewAndSubmit: { requestedDeliveryDate, requestedPickupDate },
        },
    } = props.getState();
    const tempDeliveryDate =
        typeof requestedDeliveryDate !== "undefined"
            ? requestedDeliveryDate
            : props.cartToUpdate.requestedDeliveryDateDisplay;
    const tempPickupDate =
        typeof requestedPickupDate !== "undefined"
            ? requestedPickupDate
            : props.cartToUpdate.requestedPickupDateDisplay;

    if (orderNotesDescription !== undefined || accountNo.length !== 0 || cenopcPONumber !== undefined) {
        props.apiParameter = {
            cart: {
                ...props.cartToUpdate,
                requestedDeliveryDate: convertDateToApiFormat(tempDeliveryDate),
                requestedPickupDate: convertDateToApiFormat(tempPickupDate),
                properties: { customerCollectAccountNumber: accountNo, gclid } as any,
                notes: orderNotesDescription,
                poNumber:
                    props.cartToUpdate.paymentMethod?.isCreditCard || props.cartToUpdate.paymentMethod?.isPaymentProfile
                        ? cenopcPONumber
                        : props.parameter.poNumber,
            },
        };
    } else {
        props.apiParameter = {
            cart: {
                ...props.cartToUpdate,
                requestedDeliveryDate: convertDateToApiFormat(tempDeliveryDate),
                requestedPickupDate: convertDateToApiFormat(tempPickupDate),
            },
        };
    }
};

replaceInChain(chain, PopulateApiParameter, PopulateApiParameterExtended);
